// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Destination,
  Value,
} from "./types";


export default __t.row({
  requestId: __t.u64().primaryKey().name("request_id"),
  blockNumber: __t.u64().name("block_number"),
  accountId: __t.u256().name("account_id"),
  delegatedKey: __t.option(__t.u256()).name("delegated_key"),
  get destination() {
    return Destination;
  },
  get value() {
    return Value;
  },
  refundTx: __t.option(__t.byteArray()).name("refund_tx"),
  absorbedInBlock: __t.u64().name("absorbed_in_block"),
  rejectedInBlock: __t.u64().name("rejected_in_block"),
  failureReason: __t.option(__t.string()).name("failure_reason"),
});
